import { useState, useEffect } from 'react';

function usePreloadImages(imageUrls) {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    if (!imageUrls || imageUrls.length === 0) {
      setImagesLoaded(true);
      return;
    }

    let loadedCounter = 0;
    const images = [];

    const markImageAsLoaded = () => {
      loadedCounter++;
      if (loadedCounter === imageUrls.length) {
        setImagesLoaded(true);
      }
    };

    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;
      img.onload = markImageAsLoaded;
      img.onerror = markImageAsLoaded; // Treat errors as "loaded" to prevent infinite loading
      images.push(img);
    });

    return () => {
      images.forEach(img => {
        img.onload = null;
        img.onerror = null;
      });
    };
  }, [imageUrls]); // Dependency array includes imageUrls to re-run effect if URLs change

  return [imagesLoaded];
}

export default usePreloadImages;
